import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { kpAnchorsGuard } from '~/composables/useKpAnchorsInspection';
import auth from '~/middleware/auth';
import permissionNavigationGuard from '~/middleware/permissionNavigationGuard';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.name === from.name) {
      return false;
    }

    if (savedPosition) return savedPosition;
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    return { top: 0 };
  },
});

// Adding navigation guards
// Before auth, whose redirect to the login page would drop ?kp-anchors
router.beforeEach(kpAnchorsGuard);
router.beforeEach(auth);
router.beforeEach(permissionNavigationGuard);

export default router;
